import { shuffle } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { useEventParticipants } from '../../../../../../data/hooks/participant/useEventParticipants';
import Link from '../../../../../elements/Link';
import RoundImage from '../../../../../elements/RoundImage';
import StartNetworkingIcon from '../../../../StartNetworking/StartNetworkingIcon/StartNetworkingIcon';

function HomeEventParticipantsList(props) {
    const {eventId, className = '', avatarClassName = '', size} = props,
        allParticipants = useEventParticipants(eventId),
        participants = useMemo(
            () =>
                shuffle(
                    allParticipants.filter(p => {
                        return p.user_id && p.image_url && !p.image_url.match(/no\_avatar\.png$/);
                    })
                ).slice(0, size),
            [allParticipants]
        );

    const handleIconClick = useCallback(e => e.stopPropagation(), []);

    if (!participants.length) return null;

    return (
        <>
            {participants.map((p, i) => (
                <Link
                    className={className}
                    href={['/events', eventId, 'participants', p.id || '-', p.participant_id || '-'].join('/')}
                    key={i}
                    onClick={e => {
                        e.stopPropagation();
                    }}>
                    <RoundImage className={['avatar', avatarClassName].join(' ')} src={p.image_url} altSrc="/img/no_avatar.png" size={50} />
                </Link>
            ))}
            <StartNetworkingIcon onClick={handleIconClick} />
        </>
    );
}

export default HomeEventParticipantsList;
